import React, {useEffect} from 'react';
import gtmParts from 'react-google-tag-manager';

const GoogleTagManager = (props) => {
    useEffect(() => {
        const dataLayerName = props.dataLayerName || 'dataLayer';
        const scriptId = props.scriptId || 'react-google-tag-manager';

        if (!window[dataLayerName]) {
            const gtmScriptNode = document.getElementById(scriptId);

            eval(gtmScriptNode.textContent);
        }
    });

    const gtm = gtmParts({
        id: props.gtmId || process.env.NEXT_PUBLIC_APP_GOOGLE_TAG_MANAGER,
        dataLayerName: props.dataLayerName || 'dataLayer',
        additionalEvents: props.additionalEvents || {},
        previewVariables: props.previewVariables || false,
    });

    return (
        <React.Fragment>
            <div>{gtm.noScriptAsReact()}</div>
            <div id={props.scriptId || 'react-google-tag-manager'}>
                {gtm.scriptAsReact()}
            </div>

             {/*Google Tag Manager (noscript)*/}
            <noscript>
                <iframe src={"https://www.googletagmanager.com/ns.html?id=" + process.env.NEXT_PUBLIC_APP_GOOGLE_TAG_MANAGER} height="0" width="0" style={{display:'none' , visibility:'hidden'}}/>
            </noscript>
             {/*End Google Tag Manager (noscript)*/}
        </React.Fragment>
    );
};

export default React.memo(GoogleTagManager);
